import React from 'react'
import { PageLayout } from 'app/views/components/layout/page-layout'
import DealManagementHeaderSection from './deals-management-header'
import { LockedDealDrillPage } from './locked-deals-management-drill-page'

/**
 * The Terminated Deals / Facilities landing page. It loads nothing itself:
 * each Terminated grid is the terminated rows of its tab's one read
 * (ADR_LOS-030), and the row menus fetch the record a form acts on when it
 * opens.
 */
export function LockedDealManagmentPage(tab: { tab: string }) {
  return (
    <PageLayout>
      <DealManagementHeaderSection />
      <LockedDealDrillPage tab={tab.tab} />
    </PageLayout>
  )
}
